import React, { Component } from "react";
import { connect } from "react-redux";
import swal from 'sweetalert2';
import axios from '../../../../../axios-instance';
import withReactContent from 'sweetalert2-react-content';
import ls from 'localstorage-slim';

import NewLoader from "../../../../../components/NewLoader/NewLoader";

import styles from './EventPaymentMethods.module.sass';
import { getCustomURLs } from "../../../../../helpers/getCustomURLs";
import { getHeaders } from "../../../../../helpers/getHeaders";
import CheckBox from "../../../../../components/UI/Checkbox/CheckBox";
import { paymentProvidersOptions } from "../../../../SeasonPass/constants";
import { toast } from "react-toastify";

const MySwal = withReactContent(swal);

class EventPaymentMethods extends Component {
    state = {
        eventId: this.props.match.params.id,
        currentEvent: {},
        loading: true,
        useDefault: false,
        isDisabled: true,
        paymentMethods: [],
    }

    static getDerivedStateFromProps(props, state) {
        return {
            currentEvent: { ...props.currentEvent },
        };
    };

    getPaymentMethods() {
        axios.get(`${getCustomURLs().API_URL}/PaymentMethod/event/${this.state.eventId}`,
            {
                headers: getHeaders(ls.get('user').token),
            }).then((r) => {
                this.setState({
                    useDefault: r.data.every(i => !i.isUsedForEvent),
                    paymentMethods: r.data,
                });
            }).catch(() => {
              toast.error('Something went wrong');
              this.setState({ loading: false });
            });
    }

    savePaymentMethods() {
        axios.put(`${getCustomURLs().API_URL}/PaymentMethod/event/${this.state.eventId}`,
            this.state.useDefault
                ? []
                : this.state.paymentMethods.map(m => { return { id: m.id, activated: m.isUsedForEvent } }),
            {
                headers: getHeaders(ls.get('user').token),
            }).then((r) => {
                toast.success('Payments is saved successfully')
            }).catch((e) => {
              toast.error('Payments is not saved');
            });
    };

    changeMethodEventUsing(v, id) {
        const method = this.state.paymentMethods.find(m => m.id === id);

        if (method) {
            method.isUsedForEvent = !method.isUsedForEvent;
            this.setState({ paymentMethods: this.state.paymentMethods.map(m => m) });
        }
    }

    changeMethodUseDefault(v) {
        this.setState({ useDefault: !this.state.useDefault });
    }

    validateInputs() {
        const isDisabled = !this.state.useDefault
            && this.state.paymentMethods.every(m => !m.isUsedForEvent);

        if (this.state.isDisabled !== isDisabled) {
            this.setState({
                isDisabled: isDisabled
            });
        }
    }

    componentDidMount() {
        Promise.all([this.getPaymentMethods()])
            .then(() => {
                this.setState({ loading: false })
            })
            .catch(() => {
                this.setState({ loading: false })
            });
    }

    render() {
        const {
            loading,
            useDefault,
            paymentMethods,
        } = this.state;

        if (loading) {
            return (
                <div className="wallets">
                    <NewLoader />
                </div>
            );
        }

        this.validateInputs();

        return (
            <section className={styles['container']}>
                <CheckBox
                    name="change-default"
                    id={`change-default_${0}`}
                    checked={useDefault}
                    onChange={v => this.changeMethodUseDefault(v.target.checked)}>
                    Use promoter default
                </CheckBox>

                <div disabled className={`${styles['paymentMethodsContainer']} ${useDefault && styles['disabled']}`}>
                    {paymentMethods.map(m =>
                        <div key={m.id} className={styles['item']}>
                            <strong>Payment provider: {paymentProvidersOptions.find(i => i.id === m.provider).label}</strong>

                            <div className="add-event__block" style={{marginBottom: 0}}>
                              <label>Name</label>
                              <span>{m.paymentMethodName}</span>
                            </div>

                            <div>
                                <CheckBox
                                    name="change-default"
                                    id={`change-default_${m.id}`}
                                    checked={useDefault ? m.isPromoterDefault : m.isUsedForEvent}
                                    onChange={v => this.changeMethodEventUsing(v.target.checked, m.id)}>
                                    Use for event
                                </CheckBox>


                            </div>
                        </div>)}
                </div>

                <div className={styles['footer']}>

                    <button
                        type="button"
                        className={`btn-primary-new admin ${styles['button']}`}
                        onClick={() => this.savePaymentMethods()}
                        disabled={this.state.isDisabled}
                    >
                        <span>Save</span>
                    </button>

                </div>

            </section>
        )
    }
}

const mapStateToProps = ({
    auth: { user },
    events: { currentEvent },
}) => ({ user, currentEvent });

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(EventPaymentMethods);